import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./apps/app/components/App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./apps/pages/components/home";
import AuthProvider from "./services/auth";
import Bio from "./apps/pages/components/bio";
import { ParallaxProvider } from "react-scroll-parallax";
import News from "./apps/pages/components/news";
import ArtisticDirection from "./apps/pages/components/artistic_direction";
import ArtisticDirectionPage from "./apps/pages/components/artistic_direction_page";
import Credits from "./apps/pages/components/credits";
import Gallery from "./apps/pages/components/gallery";
import NewsPage from "./apps/pages/components/news_page";
import Compositions from "./apps/pages/components/compositions";
import CompositionsPageCategory from "./apps/pages/components/compositions_page_category";
import CompositionsPageCategorySingle from "./apps/pages/components/compositions_page_category_single";
import Contacts from "./apps/pages/components/contacts";
import DashBoard from "./admin/dash_board_components/components/dash_board";
import DashHome from "./admin/dash_board_components/components/dash_home";
import CategoryEdit from "./admin/category_data_components/components/category-edit";
import Login from "./apps/pages/components/login";
import MusicEdit from "./admin/music_data_components/components/music-edit";
import CategoryList from "./admin/category_data_components/components/category-list";
import CategoryCreate from "./admin/category_data_components/components/category-create";
import MusicList from "./admin/music_data_components/components/music-list";
import MusicCreate from "./admin/music_data_components/components/music-create";
import NewsList from "./admin/news_data_components/components/news-list";
import NewsCreate from "./admin/news_data_components/components/news-create";
import NewsEdit from "./admin/news_data_components/components/news-edit";
import ProtectedRoute from "./services/protectedRoute";
import ActivityList from "./admin/activity_components/components/activity-list";
import PrivacyPolicy from "./apps/pages/components/privacy_policy";
import LegalNotes from "./apps/pages/components/legal_notes";
import CookiePolicy from "./apps/pages/components/cookie_policy";
import Search from "./apps/pages/components/search";
import Portfolio from "./apps/pages/components/portfolio";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/bio",
        element: <Bio />,
      },
      {
        path: "/news",
        element: <News />,
      },
      {
        path: "/news/:slugNews",
        element: <NewsPage />,
      },
      {
        path: "/art-direction",
        element: <ArtisticDirection />,
      },
      {
        path: "/art-direction/:dataCategory",
        element: <ArtisticDirectionPage />,
      },
      {
        path: "/credits",
        element: <Credits />,
      },
      {
        path: "/gallery",
        element: <Gallery />,
      },
      {
        path: "/compositions",
        element: <Compositions />,
      },
      {
        path: "/compositions/:categoryCompositions",
        element: <CompositionsPageCategory />,
      },
      {
        path: "/compositions/:categoryCompositions/:slugMusic",
        element: <CompositionsPageCategorySingle />,
      },
      {
        path: "/contacts",
        element: <Contacts />,
      },
      {
        path: "/portfolio",
        element: <Portfolio />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy/>,
      },
      {
        path: "/legal-notes",
        element: <LegalNotes/>,
      },
      {
        path: "/cookie-policy",
        element: <CookiePolicy/>,
      },
      {
        path: "/search",
        element: <Search/>,
      },
    ],
  },
  {
    path: "admin",
    element: <ProtectedRoute element={<DashBoard/>} />,
    children: [
      {
        index: true,
        element: <DashHome />,
      },
      {
        path: "categoryList",
        element: <CategoryList />,
      },
      {
        path: "categoryList/:idCategory",
        element: <CategoryEdit />,
      },
      {
        path: "categoryCreate",
        element: <CategoryCreate />,
      },
      {
        path: "newsList",
        element: <NewsList />,
      },
      {
        path: "newsCreate",
        element: <NewsCreate />,
      },
      {
        path: "newsList/:slugNews",
        element: <NewsEdit />,
      },
      {
        path: "musicList",
        element: <MusicList />,
      },
      {
        path: "musicList/:slugMusic",
        element: <MusicEdit />,
      },
      {
        path: "musicCreate",
        element: <MusicCreate />,
      },
      {
        path: "activityList",
        element: <ActivityList />,
      },
    ],
  },
]);

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <ParallaxProvider>
        <RouterProvider router={router} />
      </ParallaxProvider>
    </AuthProvider>
  </React.StrictMode>
);
reportWebVitals();
